import type { Block } from "../../notizbloecke/blockModell";

/**
 * Was am Notizfeld erlaubt ist — REINE Ableitung, bewusst ohne React und ohne
 * Fetch: Die Regel kostet Daten, wenn sie falsch ist, und gehört deshalb an
 * EINEN Ort mit einem Test statt als Bedingung in ein JSX-Menü.
 *
 * ══ HIER STAND DAS UMHÄNGEN (bis 20.09.2026) ═══════════════════════════════
 * `blockIstUmhaengbar`, `zuweisbareTodos` und `zuweisungsLabel` haben den
 * Rechtsklick „Notiz einem anderen To-do zuweisen" gespeist. Mit dem EINEN
 * Notizfeld gibt es keine einzeln ansprechbaren Blöcke mehr, und der PO hat
 * den Punkt gestrichen: „nein, Text kann man ja kopieren." Die Funktionen sind
 * entfallen; die Regel dahinter (eine Bestands-`TodoNote` lässt sich nicht
 * umhängen) gilt weiter im Backend.
 * ═══════════════════════════════════════════════════════════════════════════
 */

/**
 * Darf in diesem Block FORMATIERT werden?
 *
 * ══ SEIT DEM 20.09.2026: ÜBERALL ═══════════════════════════════════════════
 * Bis dahin trennte `source` auch hier den Bestand vom Neuen — nicht weil eine
 * Aktion fehlschlug, sondern weil sie STILL misslang: `TodoNote` hatte keine
 * `format`-Spalte, das Markup der Leiste ging als gewöhnlicher Text in die
 * Zeile, und beim nächsten Laden stand dort wörtlich
 * `<span class="nb-fs-24">…</span>`.
 *
 * Die Spalte gibt es jetzt (Migration `AddNotizErledigtAnkerTermin`), und
 * `noteService` schickt das Feld mit. Seit die Notizen EIN Feld sind, MUSS das
 * auch so sein: Eine Markierung läuft über Abschnittsgrenzen hinweg, und eine
 * Auszeichnung, die an der Grenze zum Bestand abbricht, wäre nicht zu
 * erklären.
 *
 * Die Funktion bleibt bestehen, damit der eine Ort für diese Frage erhalten
 * bleibt — und falls sich eine neue Grenze auftut.
 * ═══════════════════════════════════════════════════════════════════════════
 */
export function blockIstFormatierbar(_block: Pick<Block, "source">): boolean {
    return true;
}

/** Die Menüzeile zu einem Ziel — ein To-do ohne Betreff bleibt ansprechbar. */
export function zuweisungsLabel(todo: { id: number; titel?: string | null }): string {
    return `→ ${todo.titel?.trim() || `To-do ${todo.id}`}`;
}
